import { SearchFilterCondition } from "./searchfiltercondition";

export class SearchFilter {
    SearchFilterConditions?: SearchFilterCondition[];
    Skip: number;
    Take: number;
    Enabled?: boolean = true;
    constructor() {
    }
  }

 

